<template>
    <div v-if="showVideoSection">
        <div class="video-area bg-F7F7FF">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12 intro-video-cc">
                        <div class="intro-video-content">
                            <span class="sub-title text-uppercase">App Walkthrough</span>

                            <h2>Watch Our Most Watched {{ appName || 'App' }} Video</h2>
                            <p>{{ description }}</p>
                            <router-link :to="ctaLink" class="default-btn">{{ ctaText }}</router-link>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="intro-video-box">
                            <img :src="videoThumbnail" :alt="`${appName || 'App'} Video Thumbnail`">
                            <div class="video-btn" v-on:click="isPopupMethod(isPopup)" style="cursor: pointer">
                                <i class="ri-play-line"></i>
                            </div>
                            <div class="shape">
                                <img src="../../assets/images/shape/shape13.png" class="shape10" data-aos="fade-left"
                                    alt="image">
                                <img src="../../assets/images/shape/shape14.png" class="shape11" data-aos="fade-right"
                                    alt="image">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="popup-video" v-if="isPopup">
            <div class="d-table">
                <div class="d-table-cell">
                    <div class="popup-overlay-close" v-on:click="isPopupMethod(isPopup)">
                        <div class="popup-overlay-close-line"></div>
                        <div class="popup-overlay-close-line"></div>
                    </div>
                    <div class="play-video">
                        <div v-if="iframeHtml" v-html="iframeHtml"></div>
                        <div v-else>
                            <iframe src="https://www.youtube.com/embed/bk7McNUjWgw"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
@media screen and (max-width: 500px) {

    .how-it-works-steps-area {
        padding: 40px 40px 20px !important;
    }

    .screenshots-swiper-slides {
        padding-bottom: 20px !important;
    }

    .screenshots-area {
        padding-bottom: 0px !important;
    }

    .video-area {
        padding-top: 0px !important;
    }

    .intro-video-content {
        margin-bottom: 50px !important;
    }

    .section-title {
        margin-bottom: 10px;
    }

    .features-list p {
        text-align: center;
        padding: 0 20px;
    }

    .intro-video-cc {
        padding-top: 40px;
    }
}
</style>

<script>
export default {
    name: 'IntroVideoSection',
    props: {
        embed_video: { type: [Array, Object, String], default: null },
        appName: { type: String, required: true },
        heading: { type: String, required: true },
        description: { type: String, required: true },
        ctaText: { type: String, default: 'Get Started' },
        ctaLink: { type: String, default: '/contact' },
    },
    data() {
        return {
            isPopup: false
        }
    },
    computed: {
        iframeHtml() {
            const ev = this.embed_video;
            if (Array.isArray(ev) && ev[0]?.children?.[0]?.text?.includes('<iframe')) {
                return ev[0].children[0].text;
            }
            return null;
        },
        videoThumbnail() {
            const ev = this.embed_video;
            if (!ev) return '../../assets/images/video/video-img1.jpg';

            let videoUrl = '';

            // Handle different embed_video structures
            if (Array.isArray(ev) && ev[0]?.children?.[0]?.text?.includes('<iframe')) {
                const iframeText = ev[0].children[0].text;
                const srcMatch = iframeText.match(/src="([^"]+)"/);
                if (srcMatch) {
                    videoUrl = srcMatch[1];
                }
            } else if (Array.isArray(ev) && ev[0]?.children?.[1]?.url) {
                videoUrl = ev[0].children[1].url;
            } else if (typeof ev === 'string' && ev.includes('youtube')) {
                videoUrl = ev;
            }

            if (!videoUrl) return '../../assets/images/video/video-img1.jpg';

            // Extract YouTube video ID
            const videoIdMatch = videoUrl.match(/(?:youtube\.com\/embed\/|youtu\.be\/|youtube\.com\/watch\?v=)([a-zA-Z0-9_-]+)/);
            if (videoIdMatch) {
                const videoId = videoIdMatch[1];
                // Return high quality thumbnail (maxresdefault.jpg)
                return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
            }

            return '../../assets/images/video/video-img1.jpg';
        },
        showVideoSection() {
            return this.videoThumbnail !== '../../assets/images/video/video-img1.jpg';
        }
    },
    methods: {
        isPopupMethod(isPopup) {
            return this.isPopup = !isPopup
        },
    },
}
</script>